import React, { useState } from "react";
import TermsModal from "./TermsModal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./TermsAndConditions.css";

const TermsAndConditions = ({ pdfUrl, onAccept }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [accepted, setAccepted] = useState(false);

    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setAccepted(isChecked);
        toast.success(
            isChecked
                ? "You have accepted the Terms & Conditions"
                : "Terms & Conditions unchecked"
        );
        onAccept(isChecked);
    };

    return (
        <div className="terms-container">
            {/* Terms & Conditions Link */}
            <p className="terms-text">
                By continuing, you agree to our{" "}
                <span className="terms-link" onClick={() => setIsOpen(true)}>
                    Terms & Conditions
                </span>.
            </p>

            {/* Checkbox for Acceptance */}
            <div className="terms-checkbox-container">
                <input
                    type="checkbox"
                    id="terms-checkbox"
                    checked={accepted}
                    onChange={handleCheckboxChange}
                />
                <label htmlFor="terms-checkbox">
                    I have read and accept the Terms & Conditions.
                </label>
            </div>

            {/* Modal for PDF Viewer */}
            <TermsModal isOpen={isOpen} onClose={() => setIsOpen(false)} title="Terms & Conditions">
                <iframe
                    src={pdfUrl}
                    width="100%"
                    height="600px"
                    style={{ border: "none" }}
                    title="Terms and Conditions PDF"
                />
            </TermsModal>
        </div>
    );
};

export default TermsAndConditions;
